export default __webpack_public_path__ + "static/media/KZ.T.10.2072 black.a44b811f.svg";